
import useColorPickerPipette from '@/components/Common/ColorPicker/ColorPickerPipette/ColorPickerPipette';

export default {
  setup(props, context) {
    return { ...useColorPickerPipette(props, context) };
  },
};
